<template>
  <div class="b-login-page">
    <div style="font-size:2.5em;text-align: center;">
      <img src="@/assets/logo.png" />
      智慧献血屋
    </div>
    <div class="panel-border b-login-page-body">
      <q-card-section style="font-size:1.5em">欢迎登录</q-card-section>
      <div class="row-center">
        <b-login />
      </div>
    </div>
  </div>
</template>

<script>
import BLogin from './BLogin.vue'
export default {
  components: { BLogin },
  data () {
    return {

    }
  }
}
</script>

<style lang="scss">
.b-login-page {
  width: 700px;
  &-body {
    background-color: white;
    margin: 1em;
    padding: 1em;
  }
  div {
    box-shadow: none;
  }
}
</style>
